'use client'

import Link from 'next/link'
import { Dialog as DialogPrimitive } from 'radix-ui'
import { HugeiconsIcon } from '@hugeicons/react'
import { Cancel01Icon } from '@hugeicons-pro/core-stroke-rounded'

const LOGIN_HREF = '/login?next=/'
const SIGNUP_HREF = '/signup?next=/'

export function LoginGateModal({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[120] bg-black/45 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          aria-describedby="marketplace-gate-body"
          className="fixed left-1/2 top-1/2 z-[120] w-[calc(100%-2rem)] max-w-[360px] -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-atrium-border bg-white p-7 shadow-xl outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
        >
          <DialogPrimitive.Close
            aria-label="Close"
            className="absolute right-3.5 top-3.5 grid size-7 place-items-center rounded-md text-atrium-black/45 transition-colors hover:text-atrium-black focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-600/40"
          >
            <HugeiconsIcon icon={Cancel01Icon} className="size-4" />
          </DialogPrimitive.Close>

          <div className="mb-4 grid size-[42px] place-items-center rounded-[10px] bg-accent-600 text-[22px] font-bold leading-none text-white">
            a
          </div>

          <DialogPrimitive.Title className="mb-1.5 text-[21px] font-bold leading-tight tracking-tight text-atrium-black">
            Sign in to continue
          </DialogPrimitive.Title>

          <DialogPrimitive.Description
            id="marketplace-gate-body"
            className="mb-5 text-sm leading-relaxed text-atrium-black/60"
          >
            Browse the marketplace freely. Sign in to install channels, run Commands,
            and save prompts.
          </DialogPrimitive.Description>

          <Link
            href={LOGIN_HREF}
            className="mb-2 flex w-full items-center justify-center rounded-[10px] bg-accent-600 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-accent-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-600/40"
          >
            Sign in
          </Link>
          <Link
            href={SIGNUP_HREF}
            className="flex w-full items-center justify-center rounded-[10px] border border-accent-600 bg-transparent px-4 py-3 text-sm font-semibold text-accent-700 transition-colors hover:bg-accent-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-600/40"
          >
            Create account
          </Link>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
